import React from 'react';

// Stats Component
const StatsCard = ({ title, value, icon: Icon, emoji, color = "indigo" }) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-6 hover:shadow-md transition-all duration-200">
    <div className="flex items-center">
      <div className={`w-10 h-10 sm:w-12 sm:h-12 bg-${color}-100 rounded-lg flex items-center justify-center`}>
        {emoji ? (
          <span className="text-lg sm:text-xl">{emoji}</span>
        ) : (
          Icon && <Icon className={`w-5 h-5 sm:w-6 sm:h-6 text-${color}-600`} />
        )}
      </div>
      <div className="ml-3 sm:ml-4">
        <p className="text-xs sm:text-sm font-medium text-gray-600">{title}</p>
        <p className="text-lg sm:text-2xl font-bold text-gray-900">{value}</p>
      </div>
    </div>
  </div>
);

export default StatsCard;
